import React from 'react';
import BatchDetailedReport from './BatchDetailedReport';

/**
 * Detailed Batch Report (completed batch) — data-driven: renders from the
 * structured JSON returned by get_final_batch_report_json.
 */
const DetailedReport = ({ batchNumber }) => (
  <BatchDetailedReport batchNumber={batchNumber} />
);

export default DetailedReport;
